import { ServiceInjector } from '@/service/registry/ServiceInjector'
import { NotifyMessage } from '@/service/notification/NotifyMessage'

/**
 * Notification management service, holds all application level notification
 * data that will be displayed to the recipient.
 * @class NotificationService
 *
 * @property {Array<NotifyMessage>} alerts @readonly Array of all Notifications for this session
 */
export class NotificationService extends ServiceInjector {
  /**
   * @private
   * @type {Array<NotifyMessage>}
   */
  _alerts = []

  get alerts () {
    return this._alerts
  }

  /**
   * Adds notification to the alert queue
   * @param {NotifyMessage} alert
   */
  push (alert) {
    if (alert instanceof NotifyMessage && alert.valid()) {
      this._alerts.push(alert)
    } else {
      throw Error('Alert must have a message and be a valid NotifyMessage object of a valid type')
    }
  }

  /**
   * Clears notification from the alert queue
   */
  clear () {
    this._alerts = []
  }

  static injectedName () {
    return 'NotificationService'
  }
}
